import { createAction, props } from '@ngrx/store';
import { iEntregables } from '../../entrada/entrada.interface';

export const cargaEntregables = createAction('[Entregables Component] cargaEntregables', props<{ oEntregables: iEntregables[] }>());
export const cargaEntregablesCampos = createAction('[Entregables Component] cargaEntregablesCampos', props<{ oData: iEntregables[] }>());
export const resetEntregables = createAction('[Entregables Component] resetEntregables');